import Head from 'next/head';
import PropTypes from 'prop-types';

import { Image } from 'components/common';

import { bgWrap } from './styles.module.css';

const Layout = ({ pageTitle, content }) => {
  return (
    <div className="main">
      <Head>
        <title>{pageTitle}</title>
      </Head>

      <h1 className="d-none">{pageTitle}</h1>

      <div className={bgWrap}>
        <Image
          src="/assets/images/auth-background.jpg"
          alt="Authentication Page Background Image"
          layout="fill"
          objectFit="cover"
          priority
        />
      </div>
      <div className="container pt-8 pb-8 pt-md-12 pb-md-12 pt-lg-17 pb-lg-17">
        <div className="form-box">{content}</div>
      </div>
    </div>
  );
};

Layout.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  content: PropTypes.node,
};

Layout.propTypes = {
  content: null,
};

export default Layout;
